<template>
  <basic-page
    :title="$t('message.errorPage.mobileVerification.title')"
    :sub-title="$t('message.errorPage.mobileVerification.subTitle', { dealer: this.getBusinessName })"
    :call-to-action="$t('message.errorPage.mobileVerification.cta')"
    icon="mobile-icon"
    @ctaClicked="navigate"
  >
  </basic-page>
</template>

<script>
import { mapGetters } from 'vuex';
import BasicPage from '@/components/shared/BasicPage.vue';

export default {
  name: 'MobileVerificationError',
  components: {
    BasicPage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('business', ['getBusinessName']),
  },
  methods: {
    navigate() {
      this.$router.push({ name: `returning-customer-mobile-verification-${this.baseRoute}` });
    },
  },
};
</script>

<style scoped lang="scss"></style>
